// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const ProductStorefrontVisibility = {
  Always: {
    Name: 'Always',
    Value: 'always',
    Label: 'Always',
  },
  PublishedCollection: {
    Name: 'Published Collection',
    Value: 'published_collection',
    Label: 'Only in visible collections',
  },
  Hidden: {
    Name: 'Hidden',
    Value: 'hidden',
    Label: 'Hidden',
  },
} as const

export type ProductStorefrontVisibilityValue =
  (typeof ProductStorefrontVisibility)[keyof typeof ProductStorefrontVisibility]['Value']
